import { Resolve } from '@angular/router';
import { HttpResponse, HttpParams } from '@angular/common/http';
import { IFetchList } from './fetch-entity.interface';
import { ICriteria } from './criteria.interface';

export abstract class EntityListResolver<TService extends IFetchList, TList, TCriteria extends ICriteria> implements Resolve<HttpResponse<TList[]>> {
  constructor(
    private service: TService,
    private criteria: TCriteria
  ) { }

  resolve() {
    return this.service.get(this.criteria.paramsExport());
  }
}
